
import { Component, Vue, Prop } from 'vue-property-decorator'
import Mixin from '../helpers/mixin'

@Component({})
export default class SideMenu extends Mixin {
  @Prop() headerHeight: number

  anchorChangeTimeout: number | undefined = undefined

  get offsetTopSideMenu(): number {
    const heroElm = window.document.querySelector('.hero-text-media__sticky')
    // adding extra space for the sticky hero
    if (heroElm) {
      return this.isPhone || this.isTabletP ? this.headerHeight : this.headerHeight + 120
    } else {
      return this.isPhone || this.isTabletP ? this.headerHeight : this.headerHeight + 10
    }
  }

  get scrollOffset(): number {
    return this.isPhone || this.isTabletP ? this.headerHeight + 54 : this.headerHeight + 10
  }

  onActiveAnchorItemChange(event: Event, currentItem: null | HTMLAnchorElement) {
    const anchorMenu = this.$refs.anchorMenu as Vue
    if (!anchorMenu || !currentItem) return

    function scrollAnchorIntoView(anchor: HTMLAnchorElement) {
      const anchorMenuEl = anchorMenu.$el as HTMLElement
      // scroll into center - use scroll to ensure smooth scroll on ios with polyfill
      const scrollLeft =
        anchor.offsetLeft - anchorMenuEl.offsetLeft - anchorMenuEl.clientWidth / 2 + anchor.clientWidth / 2
      anchorMenuEl.scroll({ top: 0, left: scrollLeft, behavior: 'smooth' })
    }

    if (this.isPhone || this.isTabletP) {
      if (this.anchorChangeTimeout) clearTimeout(this.anchorChangeTimeout)
      /*  timeout is needed, every change is emitted
          for example, clicking to the last item when the first one is active
          causes emits for all anchors inbetween */
      this.anchorChangeTimeout = window.setTimeout(() => scrollAnchorIntoView(currentItem), 200)
    }
  }

  mounted() {
    let flag = false
    addEventListener("scroll", (event) => {
      if (event.isTrusted && !flag && document.getElementById(decodeURI(window.location.hash.substr(1)))!.offsetTop) {
        window.scrollTo({
          top: document.getElementById(decodeURI(window.location.hash.substr(1)))!.offsetTop - 132,
          behavior: "smooth"
        });
        flag = true;
      }
    });
  }
}
